export default class ContactModal {
  constructor(element) {
    this.element = element;
    this.openButton = document.querySelector('.modalopen');
    this.closeButton = this.element.querySelector('.modalclose');
    this.init();
  }

  init() {
    this.openButton.addEventListener('click', this.openModal.bind(this));
    this.closeButton.addEventListener('click', this.closeModal.bind(this));
  }

  openModal() {
    this.element.classList.remove('modalhidden');
  }

  closeModal() {
    this.element.classList.add('modalhidden');
  }
}
